import { businessClockGuard } from './core/time/business-clock-ui';
import { registrationRecoveryGuard } from './features/registration/application/registration-recovery.guard';
import { Routes } from '@angular/router';
import { LayoutComponent } from './shared/components/layout/layout.component';
import { Step1Component } from './features/registration/pages/step1/step1.component';
import { Step2Component } from './features/registration/pages/step2/step2.component';
import { Step3Component } from './features/registration/pages/step3/step3.component';
import { Step4Component } from './features/registration/pages/step4/step4.component';
import { ErrorComponent } from './features/error/error.component';
import { PaymentsResultComponent } from './features/payments-result/payments-result.component';
import { registrationPendingGuard } from './features/registration/application/registration-pending.guard';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      { path: '', redirectTo: 'step1', pathMatch: 'full' },
      { path: 'step1', canActivate: [businessClockGuard, registrationRecoveryGuard], component: Step1Component },
      { path: 'step2', canActivate: [businessClockGuard, registrationRecoveryGuard], data: { registrationEntry: true }, component: Step2Component },
      { path: 'step2/:studioId/:studioName', canActivate: [businessClockGuard, registrationRecoveryGuard], data: { registrationEntry: true }, component: Step2Component },
      // Direct entry from admin: in-studio registration
      { path: 'in_studio/:studioId/:studioName', canActivate: [businessClockGuard, registrationRecoveryGuard], data: { registrationEntry: true }, component: Step2Component },
      // Direct entry from admin: visitors questionnaire
      { path: 'visitors/:studioId/:studioName', canActivate: [businessClockGuard, registrationRecoveryGuard], data: { registrationEntry: true }, component: Step2Component },
      // Direct entry from admin: temp member registration
      { path: 'register/:studioId/:studioName/:memberId/:tempPass', canActivate: [businessClockGuard, registrationRecoveryGuard], data: { registrationEntry: true }, component: Step2Component },
      { path: 'step3', canActivate: [businessClockGuard, registrationRecoveryGuard], component: Step3Component, canDeactivate: [registrationPendingGuard] },
      { path: 'step3/:studioId/:studioName', canActivate: [businessClockGuard, registrationRecoveryGuard], component: Step3Component, canDeactivate: [registrationPendingGuard] },
      { path: 'step4/:type/:studioId', canActivate: [businessClockGuard], component: Step4Component },
      { path: 'payment/result', canActivate: [businessClockGuard], component: PaymentsResultComponent },
      { path: 'error', component: ErrorComponent },
    ],
  },
  { path: '**', redirectTo: 'step1' },
];
